/* Alsunu — mobile drawer subpanel for ANY top-level menu item that has
   children. Ported from Emekten Sofraya (es-menu-drawer.js), then
   generalized: the original version targeted one hardcoded handle
   (originally "shop"), which broke the moment the menu structure changed
   (e.g. renamed to "Featured Collection"). This version finds every
   top-level drawer trigger with a child list and wraps each one — no
   handle to keep in sync with Navigation admin.

   When a top-level item with children is tapped in the mobile drawer, it
   slides in a full subpanel: back button + title + close at top, then the
   category list below. Works without touching Horizon's theme.liquid or
   header-drawer.liquid. */
(function () {
  window.__alsMenuDrawer = { loaded: true, built: 0 };

  function setClosed(panel) {
    panel.style.setProperty('transform', 'translateX(100%)', 'important');
    panel.style.setProperty('opacity', '0', 'important');
    panel.style.removeProperty('visibility');
  }
  function setOpen(panel) {
    panel.style.setProperty('transform', 'translateX(0)', 'important');
    panel.style.setProperty('visibility', 'visible', 'important');
    panel.style.setProperty('opacity', '1', 'important');
  }

  function buildOne(trigger) {
    if (!trigger || trigger.getAttribute('data-als-panel') === '1') return false;

    var li = trigger.closest('li');
    var drawer = trigger.closest('.menu-drawer');
    var childlist = li && li.querySelector(':scope > .menu-drawer__menu--childlist, :scope > * > .menu-drawer__menu--childlist');
    if (!childlist) {
      childlist = li && li.querySelector('.menu-drawer__menu--childlist');
    }
    if (!li || !drawer || !childlist) return false;

    var isOpen = false;

    trigger.setAttribute('data-als-panel', '1');
    li.classList.add('als-subpanel');
    li.classList.remove('menu-drawer__list-item--flat');

    var titleText =
      (trigger.querySelector('.menu-drawer__menu-item-text') || {}).textContent ||
      trigger.textContent || '';
    titleText = titleText.trim();

    var caretDown =
      '<svg viewBox="0 0 10 6" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var closeX =
      '<svg viewBox="0 0 14 14" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l12 12M13 1L1 13" fill="none" stroke="currentColor" stroke-width="1.6" ' +
      'stroke-linecap="round"/></svg>';

    var panel = document.createElement('div');
    panel.className = 'menu-drawer__submenu als-subpanel__view';
    panel.setAttribute('tabindex', '-1');
    setClosed(panel);

    var nav = document.createElement('div');
    nav.className =
      'menu-drawer__nav-buttons menu-drawer__nav-buttons--with-title als-subpanel__nav';
    nav.innerHTML =
      '<button type="button" class="button menu-drawer__back-button focus-inset als-subpanel__back" aria-label="Main menu">' +
      '<span class="svg-wrapper icon-caret icon-caret--backward">' + caretDown + '</span>' +
      '<span class="als-subpanel__back-text">Main menu</span>' +
      '</button>' +
      '<a href="' + (trigger.getAttribute('href') || '#') +
      '" class="menu-drawer__title focus-inset"><span class="menu-drawer__menu-item-text">' +
      titleText + '</span></a>' +
      '<button type="button" class="button close-button menu-drawer__close-button focus-inset als-subpanel__close" aria-label="Close">' +
      '<span class="svg-wrapper">' + closeX + '</span></button>';

    childlist.parentNode.insertBefore(panel, childlist);
    panel.appendChild(nav);
    panel.appendChild(childlist);
    childlist.classList.remove('menu-drawer__menu--grid');

    if (!trigger.querySelector('.als-subpanel__caret')) {
      var caret = document.createElement('span');
      caret.className = 'svg-wrapper icon-caret icon-caret--forward als-subpanel__caret';
      caret.innerHTML = caretDown;
      trigger.appendChild(caret);
    }

    function openPanel(e) {
      if (e) e.preventDefault();
      isOpen = true;
      li.classList.add('als-subpanel--open');
      drawer.classList.add('menu-drawer--has-submenu-opened');
      setOpen(panel);
      var first = panel.querySelector('a, button');
      if (first) first.focus();
    }
    function closePanel() {
      isOpen = false;
      li.classList.remove('als-subpanel--open');
      drawer.classList.remove('menu-drawer--has-submenu-opened');
      setClosed(panel);
      trigger.focus();
    }

    trigger.setAttribute('role', 'button');
    trigger.addEventListener('click', openPanel);
    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') openPanel(e);
    });
    nav.querySelector('.als-subpanel__back').addEventListener('click', closePanel);
    nav.querySelector('.als-subpanel__close').addEventListener('click', function () {
      isOpen = false;
      li.classList.remove('als-subpanel--open');
      setClosed(panel);
      var realClose = drawer.querySelector(
        ':scope > .menu-drawer__close-button, :scope .header__icon--summary'
      );
      if (realClose) realClose.click();
    });

    var details = drawer.closest('details');
    if (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) closePanel();
      });
    }

    window.__alsMenuDrawer.built += 1;
    return true;
  }

  function build() {
    var drawers = document.querySelectorAll('.menu-drawer');
    var any = false;
    drawers.forEach(function (drawer) {
      var topLevelItems = drawer.querySelectorAll(':scope .menu-drawer__menu--mainlist > li, :scope > ul > li, :scope .menu-drawer__list-item');
      topLevelItems.forEach(function (li) {
        if (li.querySelector('.als-subpanel__view, .menu-drawer__submenu.als-subpanel__view')) return;
        var childlist = li.querySelector(':scope > .menu-drawer__menu--childlist');
        if (!childlist) return;
        var trigger = li.querySelector(':scope > [id^="HeaderDrawer-"], :scope > a[id^="HeaderDrawer-"], :scope > button[id^="HeaderDrawer-"], :scope > summary [id^="HeaderDrawer-"]');
        if (!trigger) {
          trigger = li.querySelector('[id^="HeaderDrawer-"]');
        }
        if (trigger && buildOne(trigger)) any = true;
      });
    });
    return any;
  }

  function safeBuild() {
    try { return build(); } catch (e) { return false; }
  }

  safeBuild();
  document.addEventListener('DOMContentLoaded', safeBuild, { passive: true });
  window.addEventListener('pageshow', safeBuild, { passive: true });
  document.addEventListener('shopify:section:load', safeBuild);

  /* Horizon only renders the drawer's child lists when the header block's
     "drawer accordion" setting is on; with a flat menu there is nothing to
     wrap and build() is a no-op. It used to be retried on a 250 ms interval
     for 12.5 s plus a MutationObserver over the whole document with
     `subtree: true` — constant main-thread work on every page, for a panel
     that may never exist. Scope the watch to the header, rebuild only when the
     drawer is actually opened, and disconnect once there is nothing left to
     do. */
  var header = document.querySelector('#header-component') || document.body;
  var mo = new MutationObserver(function () {
    safeBuild();
  });
  mo.observe(header, { childList: true, subtree: true });

  // The drawer markup is hydrated on first open; that is the only moment the
  // observer is really needed, so give it a hard stop afterwards.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest('.header__icon--menu, [aria-controls*="menu-drawer"], .menu-drawer')) return;
      safeBuild();
      setTimeout(function () {
        mo.disconnect();
      }, 1500);
    },
    { passive: true, capture: true }
  );

  // Nothing has opened the drawer within 10 s of load: stop watching.
  setTimeout(function () {
    mo.disconnect();
  }, 10000);
})();
